import { PopoverListButtonItem } from '@aibees/shared/components';
import {
  AuthUser,
  Member,
  MemberStatus,
  MemberType,
  Nullable,
  Workspace,
} from '@aibees/shared/definition';
import { ITEMS } from './config';

export const filterMemberEditItems = (
  item: Member,
  role: MemberType,
  workspace?: Workspace,
  user?: Nullable<AuthUser>
) => {
  const result: PopoverListButtonItem[] = [];
  const isItemSameUser = item.user?.id === user?.id;

  // Owner Role actions
  if (role === MemberType.Owner) {
    if (item.type === MemberType.Owner) {
      if (workspace?.transfer?.status !== MemberStatus.Pending) {
        result.push(ITEMS.changeOwnership);
        result.push(ITEMS.creditCap);
      } else {
        result.push(ITEMS.cancelTransfer);
      }
    } else {
      if (item.status === MemberStatus.Pending) {
        result.push(ITEMS.cancelInvite);
        result.push(ITEMS.resend);
      }
      if (item.status === MemberStatus.Active) {
        result.push(ITEMS.editRole);
        result.push(ITEMS.creditCap);
        result.push(ITEMS.creditUsage);
        if (!isItemSameUser) result.push(ITEMS.deactivate);
      }
      if (item.status === MemberStatus.disable) {
        result.push(ITEMS.reactivate);
        // result.push(ITEMS.delete); // !! removed delete action based on business decision
        result.push(ITEMS.creditUsage);
      }
      if (item.status === MemberStatus.Deleted) {
        // !! this condition does not happen due to business decision to not show deleted users in the list
        result.push(ITEMS.creditUsage);
      }
    }
  }

  // Admin Role actions
  if (role === MemberType.Admin && item.type !== MemberType.Owner) {
    if (item.status === MemberStatus.Pending) {
      result.push(ITEMS.cancelInvite);
      result.push(ITEMS.resend);
    }
    if (item.status === MemberStatus.Active) {
      result.push(ITEMS.editRole);
      result.push(ITEMS.creditUsage);
      if (!isItemSameUser) result.push(ITEMS.deactivate);
    }
    if (item.status === MemberStatus.disable) {
      result.push(ITEMS.reactivate);
      // result.push(ITEMS.delete); // !! removed delete action based on business decision
      result.push(ITEMS.creditUsage);
    }
    if (item.status === MemberStatus.Deleted) {
      // !! this condition does not happen due to business decision to not show deleted users in the list
      result.push(ITEMS.creditUsage);
    }
  }

  // User Role actions
  if (role === MemberType.User && item.type !== MemberType.Owner) {
    // members cannot do any actions
  }

  return result;
};
